import Login from "../pages/Login";
import AdminsList from "../pages/dashboard/admins/AdminsList";
import AddAdmin from "../pages/dashboard/admins/AddAdmin";
import EditAdmin from "../pages/dashboard/admins/EditAdmin";
import EditProfile from "../pages/dashboard/admins/EditProfile";
import RolesList from "../pages/dashboard/roles/RolesList";
import AddRole from "../pages/dashboard/roles/AddRole";
import EditRole from "../pages/dashboard/roles/EditRole";
import AddLead from "../pages/dashboard/lead/CreateLead";
import Home from "../pages/dashboard/home/Home";
import { Navigate } from "react-router-dom";
import LeadsList from "../pages/dashboard/lead/LeadTable";
import EditLead from "../pages/dashboard/lead/EditLead";
import AddLeadSource from "../pages/dashboard/leadSources/CreateLeadSources";
import LeadSourceList from "../pages/dashboard/leadSources/LeadSourcesTable";
import EditLeadSource from "../pages/dashboard/leadSources/EditLeadSources";
import AddBusinessCategory from "../pages/dashboard/businessCategory/AddBusinessCategory";
import BusinessCategoryList from "../pages/dashboard/businessCategory/BusinessCategoryList";
import EditBusinessCategory from "../pages/dashboard/businessCategory/EditBusinessCategory";
import AddStatusLeadContact from "../pages/dashboard/statusLeadContact/AddStatusLeadContact";
import StatusLeadContactList from "../pages/dashboard/statusLeadContact/StatusLeadContactList";
import LeadContactList from "../pages/dashboard/leadContact/leadContactList";
import AddContactLead from "../pages/dashboard/leadContact/AddleadContact";
import EditLeadContact from "../pages/dashboard/leadContact/EditLeadContact";
import EditLeadContacts from "../pages/dashboard/leadContact/EditLeadContact";

import AddStatusDeal from "../pages/dashboard/statusDeal/AddStatusDeal";
import EditStatusDeal from "../pages/dashboard/statusDeal/EditStatusDeal";
import StatusDealList from "../pages/dashboard/statusDeal/StatusDealList";
import AddService from "../pages/dashboard/serviceDeal/AddServiceDeal";
import EditService from "../pages/dashboard/serviceDeal/EditServiceDeal";
import ServiceList from "../pages/dashboard/serviceDeal/ServiceDealList";
import LogList from "../pages/dashboard/logDeal/LogDealList";
import EditLog from "../pages/dashboard/logDeal/EditLogDeal";
import AddLog from "../pages/dashboard/logDeal/AddLogDeal";
import AddDeliverable from "../pages/dashboard/deliverableDeal/AddDeliverableDeal";
import EditDeliverable from "../pages/dashboard/deliverableDeal/EditDeliverableDeal";
import DeliverableList from "../pages/dashboard/deliverableDeal/DeliverableDealList";
import AddFeedback from "../pages/dashboard/feedbackDeal/AddFeddbackDeal";
import EditFeedback from "../pages/dashboard/feedbackDeal/EditFeddbackDeal";
import FeedbackList from "../pages/dashboard/feedbackDeal/FeddbackDealList";
import AddDeal from "../pages/dashboard/deal/AddDeal";
import EditDeal from "../pages/dashboard/deal/EditDeal";
import DealList from "../pages/dashboard/deal/DealList";
import EditStatusLeadContact from "../pages/dashboard/statusLeadContact/EditStatusLeadContact";
import Reports from "../pages/dashboard/reports/Reports";
import DealShow from "../pages/dashboard/deal/DealShow";
import LeadShow from "../pages/dashboard/lead/LeadShow";
import FileViewer from "../pages/FileViewer/FileViewer";

const adminRoutes = [
  {
    path: "/admins",
    element: <AdminsList />,
  },
  // {
  //   path: "/users",
  //   element: <UsersList />,
  // },
  // {
  //   path: "/my-admins",
  //   element: <MyAdminsList,
  ///>},
  {
    path: "/add-admin",
    element: <AddAdmin />,
  },
  {
    path: "/admins/edit-admin/:id",
    element: <EditAdmin />,
  },
  // {
  //   path: "/get-admin/:id",
  ///>},
  { path: "/edit-profile", element: <EditProfile /> },

  // {
  //   path: "/configration",
  //   element: <Configration,
  ///>},
  // {
  //   path: "/all-notifications",
  ///>},
];

const authProtectedRoutes = [
  { path: "/home", element: <Home /> },

  ...adminRoutes,
  { path: "/roles", element: <RolesList /> },
  {
    path: "/add-role",
    element: <AddRole />,
    // permission: PERMISSIONS.ROLE_CREATE,
  },
  {
    path: "roles/edit/:id",
    element: <EditRole />,
    // permission: PERMISSIONS.ROLE_EDIT,
  },
  { path: "/leads", element: <LeadsList /> },
  { path: "/leads/add", element: <AddLead /> },
  { path: "/leads/edit/:id", element: <EditLead /> },
  { path: "/leads/show/:id", element: <LeadShow /> },

  { path: "/lead-sources/add", element: <AddLeadSource /> },
  { path: "/lead-sources", element: <LeadSourceList /> },
  { path: "/lead-sources/edit/:id", element: <EditLeadSource /> },
  { path: "/business-categories/", element: <BusinessCategoryList /> },
  { path: "/business-categories/add", element: <AddBusinessCategory /> },
  { path: "/business-categories/edit/:id", element: <EditBusinessCategory /> },

  { path: "/statusleadcontacts/edit/:id", element: <EditStatusLeadContact /> },
  { path: "/statusLeadContacts/", element: <StatusLeadContactList /> },
  { path: "/statusleadcontacts/add", element: <AddStatusLeadContact /> },

  { path: "/lead-contacts/edit/:id", element: <EditLeadContacts /> },
  { path: "/lead-contacts/", element: <LeadContactList /> },
  { path: "/lead-contacts/add", element: <AddContactLead /> },

  { path: "/status-deals/edit/:id", element: <EditStatusDeal /> },
  { path: "/status-deals/", element: <StatusDealList /> },
  { path: "/status-deals/add", element: <AddStatusDeal /> },

  { path: "/services/edit/:id", element: <EditService /> },
  { path: "/services/", element: <ServiceList /> },
  { path: "/services/add/", element: <AddService /> },

  { path: "/logs/edit/:id", element: <EditLog /> },
  { path: "/logs/get/:dealId", element: <LogList /> },
  { path: "/logs/:dealId", element: <AddLog /> },

  { path: "/deliverables/edit/:id", element: <EditDeliverable /> },
  { path: "/deliverables/get/:dealId", element: <DeliverableList /> },
  { path: "/deliverables/add/:dealId", element: <AddDeliverable /> },

  { path: "/feedback/edit/:id", element: <EditFeedback /> },
  { path: "/feedback/get/:dealId", element: <FeedbackList /> },
  { path: "/feedback/add/:dealId", element: <AddFeedback /> },

  { path: "/deals/edit/:id", element: <EditDeal /> },
  { path: "/deals/", element: <DealList /> },
  { path: "/deals/add/", element: <AddDeal /> },
  { path: "/deals/show/:id", element: <DealShow /> },

  // { path: "/file-viewer", element: <FileViewer /> },
  { path: "/reports/", element: <Reports /> },
];

const publicRoutes = [
  { path: "/login", element: <Login /> },
  { path: "/", element: <Navigate to="/login" /> },
];

export { authProtectedRoutes, publicRoutes };
